/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\TinyMCE\TinyEditor.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Tuesday August 1st 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday August 1st 2023 2:12:12 pm
 * Modified By: the developer formerly known as Jonathan Mazat at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { Dispatch, forwardRef, Fragment, SetStateAction, useImperativeHandle, useRef } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { Editor as TinyMCEEditor} from 'tinymce';
import translator from 'MultiLanguage/TranslationWrapper';
import Styles from "Content/TinyMCE/TinyEditor.module.css";
import "Content/TinyMCE/TinyMCE.remove.css";

export interface TinyEditorHandle {
  getContent: () => string;
}

type TinyEditorProps = {
  id: string | null;
  messageToDisplay: string | null;
  messageName: string | null;
  deleteMessage: Function;
  setDataUpdated: Dispatch<SetStateAction<string | null>>;
  displayMenuBar: boolean;
  handleSaveMessage: Function;
  disabled?: boolean;
};

const TinyEditor = forwardRef<TinyEditorHandle, TinyEditorProps>((props, ref) => {
  // const labelList = ["Name", "Sell", "SellList", "SellLink", "DateTime", "DateTimeEnd", "AccountLink", "Login", "Alerts", "HaltSpam", "Car"];
  const editorRef = useRef<TinyMCEEditor | null>(null);

  // const addText = (val: string) => {
  //   if (editorRef.current) {
  //     editorRef.current.selection.setContent(`<span style=\"color: limegreen; font-weight:bold\" contenteditable=false data-value=${val}>[${translator.decode(`messages.labels.${val}`)}]</span> `, {format: "raw"});
  //     editorRef.current.focus();
  //   }
  // };

  useImperativeHandle(ref, () => ({
    getContent: () => {
      return editorRef.current?.getContent() || "";
    },
  }));

  const saveChange = () => {
    if (editorRef.current) {
      const Content = editorRef.current.getContent();
      props.handleSaveMessage(Content);
    }
  };

  return (
    <Fragment>
      <div className={`${Styles.editorHolder}`}>
        <div className={`${Styles.editorHeader}`}>
          <h4> {props.messageName} </h4>
          {!props.disabled && <button className="btn btn-outline-danger" disabled={props.messageName != null ? false : true} onClick={() => props.deleteMessage()}>{translator.decode("dynamic.delete")}</button>}
        </div>
        <Editor
          tinymceScriptSrc={'/tinymce/tinymce.min.js'}
          onInit={(evt, editor) => editorRef.current = editor}
          initialValue={props.messageToDisplay ?? translator.decode("messages.selectMessage")}
          disabled={props.disabled}
          init={{
            height: 500,
            menubar: props.displayMenuBar,
            plugins: [
              'advlist', 'autolink', 'lists', 'link', 'image', 'charmap',
              'anchor', 'searchreplace', 'visualblocks', 'code', 'fullscreen',
              'insertdatetime', 'media', 'table', 'preview', 'wordcount'
            ],
            toolbar: 'undo redo | blocks | ' +
              'bold italic forecolor | alignleft aligncenter ' +
              'alignright alignjustify | bullist numlist outdent indent | ' +
              'removeformat | ' +
              'image | ',

            content_style: 'body { font-family: Helvetica, Arial, sans-serif; font-size:14px }',
            image_list: [
              // {title: 'My image 1', value: 'https://www.example.com/my1.jpeg'},
              // {title: 'My image 2', value: 'http://www.example.com/my2.jpeg'}
            ],
          }}
        />
        {!props.disabled && <button className="btn btn-outline-primary mt-1" disabled={props.messageName != null ? false : true} onClick={saveChange}> {translator.decode("dynamic.save")} </button>}
      </div>
      {/* <LiCustom data={labelList} translateKey="messages.labels" tooltipKey="messages.labels.tooltip" onClick={addText} title={translator.decode("dynamic.label")} /> */}
    </Fragment>
  );
});

export default TinyEditor;
